import { createI18nInstance } from '@doordash/lib-i18n';
import englishStrings from './translations/en-US';
var i18n = createI18nInstance({
    englishStrings: englishStrings,
});
export default i18n;
